import { clone, curry, mergeDeepRight, path } from "ramda";
import { useContext } from "react";
import { DefaultPropsContext } from "./default-props.provider";
import { safeMerge } from "@components-common/utils";
import { ToolbarProps } from "@components-common/types";

export const useDefaults = <TProps>(type: string, id:string) => {
  const defaultProps = useContext(DefaultPropsContext);
  const result = path<TProps>([type, id], defaultProps);
  return clone(result);
};

export const useWithDefaults = <TProps extends object>(type: string, id:string, props:TProps) => {
  const defaultProps = useDefaults<TProps>(type,id);
  const result = safeMerge(defaultProps!,props);
  return result;
};
export const useWithDefaultBuilder = (category:string, type:string,) => curry(useWithDefaults)(category)(type);
export const useWithDefaultColumn = curry(useWithDefaults)("column");
export const useWithDefaultButton = curry(useWithDefaults)("button");
export const useWithDefaultTable = curry(useWithDefaults)("table");
export const useWithDefaultToolbar = curry(useWithDefaults<ToolbarProps>)("toolbar");
export const useWithDefaultForm = curry(useWithDefaults)("form");
export const useWithDefaultScreen = (x:any) => useWithDefaults("screen",x.type,x);
